module.exports = __webpack_public_path__ + "media/mypage/images/special/000-7cc57c9ff990523bf673946148e851c0.jpg";